import React, { PropTypes } from 'react'
import classNames from 'classnames'
import CSSModules from 'react-css-modules'

import styles from './box.css'

const Box = ({ children, first, interactive, last, padding, single }) => {
  const className = classNames('box', `box-padding-${padding}`, {
    'box-border-first': !single && first,
    'box-border-last': !single && last,
    'box-border-middle': !single && !first && !last,
    'box-border-single': single,
    'box-interactive': interactive,
  })

  return (
    <div styleName={className}>
      {children}
      {interactive && <div styleName="shadow"></div>}
    </div>
  )
}

Box.propTypes = {
  children: PropTypes.any,
  first: PropTypes.bool,
  interactive: PropTypes.bool,
  last: PropTypes.bool,
  single: PropTypes.bool,
  padding: PropTypes.oneOf(['none', 'small', 'medium', 'large']),
}

Box.defaultProps = {
  padding: 'none',
  single: true,
}

export default CSSModules(Box, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/box/box.js
 **/